import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";

export default function FileUpload({ show, handleClose, SendSKUQtyToItemInquiry }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [importDealerModal, setImportDealerModal] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [pop, setPop] = useState(false);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const getExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    }

    const handleUpload = async () => {
        setErrorMsg('');
        if (!selectedFile) {
            setErrorMsg('Please select a file first!');
            return;
        }
        if (getExtension(selectedFile.name) !== 'txt') {
            setErrorMsg('Please select a txt file!');
            return;
        }

        handlePop();
        const formData = new FormData();
        formData.append('file', selectedFile, selectedFile.name);
        const requestOptions = {
            method: 'POST',
            headers: {
                //'Content-type': 'multipart/form-data',
                Accept: "application/json",
            },
            
            body: formData
        };
        try {
            const response = await fetch('kdealer/ImportFile', requestOptions);
            if (response.status === 200) {
                handleClosePop();
                const js = await response.json();
                if (SendSKUQtyToItemInquiry) {
                    SendSKUQtyToItemInquiry(js);
                }
                setSelectedFile(null);
            }
        } catch (error) {
            console.error('File upload error:', error);
            handleClosePop();
            alert('File upload failed!');
        }
    };

    const handleImportModalClose = () => {
        setImportDealerModal(false);
    }

    const handleImportModalShow = () => {
        setImportDealerModal(true);
    }

    const importOrder = () => {
        handleImportModalClose();
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>IMPORT ORDER</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className="text-center">
                            <input type="file" onChange={handleFileChange} />
                            {selectedFile && (
                                <p className="mt-3 mb-0">
                                    Selected file: {selectedFile.name} ({selectedFile.type}, {selectedFile.size}{' '}
                                    bytes)
                                </p>
                            )}
                        </Col>
                        {ErrorMsg &&
                            <Col sm={12}>
                                <p className="mt-4 mb-0 red">{ErrorMsg}</p>
                            </Col>
                        }
                    </Row>
                </Modal.Body>
                <Modal.Footer className="text-right">
                    {/*<Button variant="secondary" onClick={handleImportModalClose}>*/}
                    {/*    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">*/}
                    {/*        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                    {/*    </svg>*/}
                    {/*    CANCEL*/}
                    {/*</Button>*/}
                    <Button variant="primary" onClick={handleUpload}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        UPLOAD
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}

